import {metadaApi} from '@dms/api/base';

import {
  GetVehicleClassRequest,
  GetVehicleClassRequestSchema,
  GetVehicleClassResponse,
  GetVehicleClassResponseSchema,
  GetVehicleClassesRequest,
  GetVehicleClassesRequestSchema,
  GetVehicleClassesResponse,
  GetVehicleClassesResponseSchema,
  PatchVehicleClassRequest,
  PatchVehicleClassRequestSchema,
  PatchVehicleClassResponse,
  PatchVehicleClassResponseSchema,
  PostVehicleClassRequest,
  PostVehicleClassRequestSchema,
  PostVehicleClassResponse,
  DeleteVehicleClassRequest,
  DeleteVehicleClassRequestSchema,
  DeleteVehicleClassResponse,
  DeleteVehicleClassResponseSchema,
  PostVehicleClassResponseSchema,
  PostVehicleClassSetAsActiveRequest,
  PostVehicleClassSetAsActiveResponse,
  PostVehicleClassSetAsActiveResponseSchema,
  PostVehicleClassSetAsActiveRequestSchema,
  PostVehicleClassSetAsInactiveRequest,
  PostVehicleClassSetAsInactiveResponse,
  PostVehicleClassSetAsInactiveResponseSchema,
  PostVehicleClassSetAsInactiveRequestSchema,
} from './types';

export const metadaWorkshopVehicleClassApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getVehicleClasses: build.query<GetVehicleClassesResponse, GetVehicleClassesRequest>({
      query: () => ({
        url: `core/v1/vehicle-class`,
        method: 'GET',
      }),
      providesTags: ['vehicleClasses'],
      extraOptions: {
        requestSchema: GetVehicleClassesRequestSchema,
        responseSchema: GetVehicleClassesResponseSchema,
      },
    }),
    getVehicleClass: build.query<GetVehicleClassResponse, GetVehicleClassRequest>({
      query: (queryArg) => ({
        url: `core/v1/vehicle-class/${queryArg.vehicleClassId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'vehicleClasses', id: queryArg.vehicleClassId},
      ],
      extraOptions: {
        requestSchema: GetVehicleClassRequestSchema,
        responseSchema: GetVehicleClassResponseSchema,
      },
    }),
    postVehicleClass: build.mutation<PostVehicleClassResponse, PostVehicleClassRequest>({
      query: (queryArg) => ({
        url: `core/v1/vehicle-class`,
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      extraOptions: {
        requestSchema: PostVehicleClassRequestSchema,
        responseSchema: PostVehicleClassResponseSchema,
      },
      invalidatesTags: ['vehicleClasses'],
    }),
    patchVehicleClass: build.mutation<PatchVehicleClassResponse, PatchVehicleClassRequest>({
      query: (queryArg) => ({
        url: `core/v1/vehicle-class/${queryArg.vehicleClassId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'vehicleClasses', id: queryArg.vehicleClassId},
      ],
      extraOptions: {
        requestSchema: PatchVehicleClassRequestSchema,
        responseSchema: PatchVehicleClassResponseSchema,
      },
    }),
    postVehicleClassSetAsActive: build.mutation<
      PostVehicleClassSetAsActiveResponse,
      PostVehicleClassSetAsActiveRequest
    >({
      query: (queryArg) => ({
        url: `core/v1/vehicle-class/${queryArg.vehicleClassId}/set-active`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'vehicleClasses', id: queryArg.vehicleClassId},
      ],
      extraOptions: {
        requestSchema: PostVehicleClassSetAsActiveRequestSchema,
        responseSchema: PostVehicleClassSetAsActiveResponseSchema,
      },
    }),
    postVehicleClassSetAsInactive: build.mutation<
      PostVehicleClassSetAsInactiveResponse,
      PostVehicleClassSetAsInactiveRequest
    >({
      query: (queryArg) => ({
        url: `core/v1/vehicle-class/${queryArg.vehicleClassId}/set-inactive`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'vehicleClasses', id: queryArg.vehicleClassId},
      ],
      extraOptions: {
        requestSchema: PostVehicleClassSetAsInactiveRequestSchema,
        responseSchema: PostVehicleClassSetAsInactiveResponseSchema,
      },
    }),
    deleteVehicleClass: build.mutation<DeleteVehicleClassResponse, DeleteVehicleClassRequest>({
      query: (queryArg) => ({
        url: `core/v1/vehicle-class/${queryArg.vehicleClassId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'vehicleClasses', id: queryArg.vehicleClassId},
      ],
      extraOptions: {
        requestSchema: DeleteVehicleClassRequestSchema,
        responseSchema: DeleteVehicleClassResponseSchema,
      },
    }),
  }),
});

export const {
  useGetVehicleClassesQuery,
  useGetVehicleClassQuery,
  usePostVehicleClassMutation,
  usePatchVehicleClassMutation,
  useDeleteVehicleClassMutation,
  usePostVehicleClassSetAsActiveMutation,
  usePostVehicleClassSetAsInactiveMutation,
} = metadaWorkshopVehicleClassApi;
